import { useState, useEffect } from 'react';
import { searchVehicles } from '../api';

interface Props {
  placeholder: string;
  onSelect: (v: { id: number; registration_number: string }) => void;
}

export default function VehicleSearchField({ placeholder, onSelect }: Props) {
  const [q, setQ] = useState('');
  const [hits, setHits] = useState<{ id: number; registration_number: string }[]>([]);

  useEffect(() => {
    if (!q.trim()) { setHits([]); return; }
    const tid = setTimeout(async () => setHits(await searchVehicles(q)), 300);
    return () => clearTimeout(tid);
  }, [q]);

  return (
    <div className="relative inline-block">
      <input
        autoFocus
        type="text"
        className="input text-xs w-40"
        placeholder={placeholder}
        value={q}
        onChange={e => setQ(e.target.value)}
      />
      {hits.length > 0 && (
        <ul className="absolute left-0 top-full z-20 bg-white border rounded shadow-md w-52 text-xs mt-0.5">
          {hits.map(v => (
            <li
              key={v.id}
              className="px-3 py-1.5 hover:bg-[var(--color-primary-soft-bg)] cursor-pointer"
              onClick={() => { onSelect(v); setQ(''); setHits([]); }}>
              {v.registration_number}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
